export default __webpack_public_path__ + "static/media/ipc-success01.28a0188e.svg";